import React from "react";
import Dummy_Image from "../../asset/images/IBA/Account_Ope_Bar_Chart.svg";

function AccountOpenBarChart() {
  return (
    <>
      <div className="card-title">
        <h2 className="h2-css-all">Account Opening Overview</h2>
        <div className="right-side-dwnld-btn">
          <span className="icon-downloadIBA"></span>
          <button>Download Report</button>
        </div>
      </div>
      <div className="card-contnent">
        <img src={Dummy_Image} alt="dummyBarChart" />
      </div>
    </>
  );
}

export default AccountOpenBarChart;
